import React, { FC } from 'react';
// import { makeStyles, withStyles } from '@material-ui/core/styles';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid';
// import moment from 'moment';
import StepConnector from '@mui/material/StepConnector';
import clsx from 'clsx';
import Check from '@mui/icons-material/Check';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { makeStyles } from 'tss-react/mui';
import { withStyles } from 'tss-react/mui';

interface LooseObject {
    [key: string]: any;
}

// const ColorlibConnector = withStyles({
    const ColorlibConnector = withStyles(StepConnector,
        () => ({
        root: {
            minHeight: '30px',
            },
    alternativeLabel: {
        top: 12,
        left: 'calc(-50% - 5px)',
        right: 'calc(50%)',
    },
    line: {
        height: 1,
        border: 0,
        backgroundColor: '#000',
        borderRadius: 1,
    },
}),)

// const useColorlibStepIconStyles = makeStyles({
    const useColorlibStepIconStyles = makeStyles()({
    root: {
        backgroundColor: '#ccc',
        zIndex: 1,
        color: '#fff',
        width: 24,
        height: 24,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    circle: {
        // width: 8,
        // height: 8,
        // borderRadius: '50%',
        backgroundColor: '#7f7f73',
    },
    active: {
        // backgroundImage: 'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
        // boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
        backgroundColor: '#c9ca4a',
    },
    completed: {
        backgroundColor: '#c9ca4a',
        color: '#fff',
        borderRadius: '50%',
    },
});

function ColorlibStepIcon(props) {
    const {classes} = useColorlibStepIconStyles();
    const { active, completed } = props;

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
            })}
        >
            {completed ? (
                <Check className={classes.completed} />
            ) : active ? (
                <Check className={classes.completed} />
            ) : (
                <div className={classes.circle} />
            )}
        </div>
    );
}

ColorlibStepIcon.propTypes = {
    /**
     * Whether this step is active.
     */
    active: PropTypes.bool,
    /**
     * Mark the step as completed. Is passed to child components.
     */
    completed: PropTypes.bool,
};

// const useStyles = makeStyles(theme => ({
    const useStyles = makeStyles()((theme) => {
return {
    root: {
        width: '100%',
        '& .MuiStepper-root': {
            padding: theme.spacing(3, 0),
            '& .MuiStep-horizontal': {
                padding: theme.spacing(0),
                width: '20%',
                margin: theme.spacing(1),
            },
        },
        '& .MuiListItem-root': {
            padding: theme.spacing(0),
            '& .MuiListItemText-root': {
                flex: '1 1',
                margin: theme.spacing(0.25),
                '& .MuiTypography-body1': {
                    fontSize: '0.6rem',
                    fontFamily: 'Avenir-Heavy',
                },
                '& .MuiTypography-body2': {
                    fontSize: '0.6rem',
                    fontFamily: 'Avenir-Medium',
                },
            },
        },
        '& .MuiTypography-body2': {
            fontSize: '0.8rem',
            fontFamily: 'Avenir-Medium',
        },
        '& .MuiTypography-body1': {
            fontSize: '0.6rem',
            fontFamily: 'Avenir-Heavy',
        },
        '& .MuiTypography-subtitle1': {
            fontSize: '0.6rem',
            // fontFamily: 'Avenir-Heavy',
        },
        '& .MuiStepConnector-alternativeLabel': {
            // left: 'calc(-50%)',
            // right: 'calc(50%)',
            '& .MuiStepConnector-lineHorizontal': {
                borderWidth: '1px',
            },
        },
        '& .MuiStepIcon-root.MuiStepIcon-completed': {
            color: '#c4c745',
        },
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
}});

const timeConverter = (minutes: string | null | undefined): string => {
    if (minutes != null) {
        const hours = parseInt(minutes) / 60;
        const rhours = Math.floor(hours);
        const min = (hours - rhours) * 60;
        const rmin = Math.round(min);
        return rhours + 'h' + ' ' + rmin + 'm';
    } else {
        return '';
    }
};

function getSteps(data) {
    switch (data.Status) {
        case 'Loading':
            return {
                steps: 1,
                data: [
                    {
                        key: 'Accepted',
                        date: data.AcceptedDateTime
                            ? moment
                                  .utc(data.AcceptedDateTime)
                                  .tz('America/Chicago')
                                  .format('MMMM DD, YYYY h:mm:ss a')
                            : '',
                        data: [
                            { key: 'Truck', value: data.TruckNumber },
                            { key: 'Chassis', value: data.ChassisNumber },
                            { key: 'Box', value: data.BoxNumber },
                        ],
                    },
                    {
                        key: 'Loading',
                        text: ``,
                        date: data.AtLofaIn
                            ? moment
                                  .utc(data.AtLofaIn)
                                  .tz('America/Chicago')
                                  .format('MMMM DD, YYYY h:mm:ss a')
                            : '',
                        data: [{ key: 'Load Facility', value: data.LofaName || 'Loading Facilty' }],
                    },
                    {
                        key: 'Loaded',
                        text: ``,
                        date: '',
                        data: [],
                    },
                    {
                        key: 'On-Site',
                        text: ``,
                        date: '',
                        Data: [],
                    },
                    {
                        key: 'Delivered',
                        date: '',
                        data: [],
                    },
                ],
            };
        case 'Loaded':
            return {
                steps: 2,
                data: [
                    {
                        key: 'Accepted',
                        date: data.AcceptedDateTime
                            ? moment
                                  .utc(data.AcceptedDateTime)
                                  .tz('America/Chicago')
                                  .format('MMMM DD, YYYY h:mm:ss a')
                            : '',
                        data: [
                            { key: 'Truck', value: data.TruckNumber },
                            { key: 'Chassis', value: data.ChassisNumber },
                            { key: 'Box', value: data.BoxNumber },
                        ],
                    },
                    {
                        key: 'Loading',
                        text: `Wait Time: ${timeConverter(data.LofaWaitTime)}`,
                        date: data.AtLofaIn
                            ? moment
                                  .utc(data.AtLofaIn)
                                  .tz('America/Chicago')
                                  .format('MMMM DD, YYYY h:mm:ss a')
                            : '',
                        data: [{ key: 'Lofa', value: data.LofaName || 'Loading Facilty' }],
                    },
                    {
                        key: 'Loaded',
                        text: ``,
                        date: data.AtLofaOut
                            ? moment
                                  .utc(data.AtLofaOut)
                                  .tz('America/Chicago')
                                  .format('MMMM DD, YYYY h:mm:ss a')
                            : '',
                        data: [{ key: 'Weight', value: data.Weight }],
                    },
                    {
                        key: 'On-Site',
                        text: ``,
                        date: '',
                        Data: [],
                    },
                    {
                        key: 'Delivered',
                        date: '',
                        data: [],
                    },
                ],
            };
        case 'On-site':
            return {
                steps: 3,
                data: [
                    {
                        key: 'Accepted',
                        date: data.AcceptedDateTime
                            ? moment
                                  .utc(data.AcceptedDateTime)
                                  .tz('America/Chicago')
                                  .format('MMMM DD, YYYY h:mm:ss a')
                            : '',
                        data: [
                            { key: 'Truck', value: data.TruckNumber },
                            { key: 'Chassis', value: data.ChassisNumber },
                            { key: 'Box', value: data.BoxNumber },
                        ],
                    },
                    {
                        key: 'Loading',
                        text: `Wait Time: ${timeConverter(data.LofaWaitTime)}`,
                        date: data.AtLofaIn
                            ? moment
                                  .utc(data.AtLofaIn)
                                  .tz('America/Chicago')
                                  .format('MMMM DD, YYYY h:mm:ss a')
                            : '',
                        data: [{ key: 'Lofa', value: data.LofaName || 'Loading Facilty' }],
                    },
                    {
                        key: 'Loaded',
                        text: `${data.MilesFromWell} miles(s)`,
                        date: data.AtLofaOut
                            ? moment
                                  .utc(data.AtLofaOut)
                                  .tz('America/Chicago')
                                  .format('MMMM DD, YYYY h:mm:ss a')
                            : '',
                        data: [{ key: 'Weight', value: data.Weight }],
                    },
                    {
                        key: 'On-Site',
                        text: ``,
                        date: data.AtDestinationIn
                            ? moment
                                  .utc(data.AtDestinationIn)
                                  .tz('America/Chicago')
                                  .format('MMMM DD, YYYY h:mm:ss a')
                            : '',
                        Data: [],
                    },
                    {
                        key: 'Delivered',
                        date: '',
                        data: [],
                    },
                ],
            };
        case 'Delivered':
        case 'Completed':
            return {
                steps: 4,
                data: [
                    {
                        key: 'Accepted',
                        date: data.AcceptedDateTime
                            ? moment
                                  .utc(data.AcceptedDateTime)
                                  .tz('America/Chicago')
                                  .format('MMMM DD, YYYY h:mm:ss a')
                            : '',
                        data: [
                            { key: 'Truck', value: data.TruckNumber },
                            { key: 'Chassis', value: data.ChassisNumber },
                            { key: 'Box', value: data.BoxNumber },
                        ],
                    },
                    {
                        key: 'Loading',
                        text: `Wait Time: ${timeConverter(data.LofaWaitTime)}`,
                        date: data.AtLofaIn
                            ? moment
                                  .utc(data.AtLofaIn)
                                  .tz('America/Chicago')
                                  .format('MMMM DD, YYYY h:mm:ss a')
                            : '',
                        data: [{ key: 'Lofa', value: data.LofaName || 'Loading Facilty' }],
                    },
                    {
                        key: 'Loaded',
                        text: `${data.MilesFromWell} miles(s)`,
                        date: data.AtLofaOut
                            ? moment
                                  .utc(data.AtLofaOut)
                                  .tz('America/Chicago')
                                  .format('MMMM DD, YYYY h:mm:ss a')
                            : '',
                        data: [{ key: 'Weight', value: data.Weight }],
                    },
                    {
                        key: 'On-Site',
                        text: `Wait Time: ${timeConverter(data.WellWaitTime)}`,
                        date: data.AtDestinationIn
                            ? moment
                                  .utc(data.AtDestinationIn)
                                  .tz('America/Chicago')
                                  .format('MMMM DD, YYYY h:mm:ss a')
                            : '',
                        Data: [],
                    },
                    {
                        key: 'Delivered',
                        date: data.AtDestinationOut
                            ? moment
                                  .utc(data.AtDestinationOut)
                                  .tz('America/Chicago')
                                  .format('MMMM DD, YYYY h:mm:ss a')
                            : '',
                        data: [
                            { key: 'Box 1', value: data.EmptyBox1 },
                            { key: 'Box 2', value: data.EmptyBox2 },
                        ],
                    },
                ],
            };
        case 'Assigned':
            if (data.AcceptedDateTime) {
                return {
                    steps: 0,
                    data: [
                        {
                            key: 'Accepted',
                            date: data.AcceptedDateTime
                                ? moment
                                      .utc(data.AcceptedDateTime)
                                      .tz('America/Chicago')
                                      .format('MMMM DD, YYYY h:mm:ss a')
                                : '',
                            data: [
                                { key: 'Truck', value: data.TruckNumber },
                                { key: 'Chassis', value: data.ChassisNumber },
                                { key: 'Box', value: data.BoxNumber },
                            ],
                        },
                        {
                            key: 'Loading',
                            text: ``,
                            date: '',
                            data: [],
                        },
                        {
                            key: 'Loaded',
                            text: ``,
                            date: '',
                            data: [],
                        },
                        {
                            key: 'On-Site',
                            text: ``,
                            date: '',
                            Data: [],
                        },
                        {
                            key: 'Delivered',
                            date: '',
                            data: [],
                        },
                    ],
                };
            } else {
                return {
                    steps: -1,
                    data: [
                        {
                            key: 'Accepted',
                            date: '',
                            data: [],
                        },
                        {
                            key: 'Loading',
                            text: ``,
                            date: '',
                            data: [],
                        },
                        {
                            key: 'Loaded',
                            text: ``,
                            date: '',
                            data: [],
                        },
                        {
                            key: 'On-Site',
                            text: ``,
                            date: '',
                            Data: [],
                        },
                        {
                            key: 'Delivered',
                            date: '',
                            data: [],
                        },
                    ],
                };
            }
        default:
            return {
                steps: -1,
                data: [
                    {
                        key: 'Accepted',
                        date: '',
                        data: [],
                    },
                    {
                        key: 'Loading',
                        text: ``,
                        date: '',
                        data: [],
                    },
                    {
                        key: 'Loaded',
                        text: ``,
                        date: '',
                        data: [],
                    },
                    {
                        key: 'On-Site',
                        text: ``,
                        date: '',
                        Data: [],
                    },
                    {
                        key: 'Delivered',
                        date: '',
                        data: [],
                    },
                ],
            };
    }
}

interface NotificationStepperProps {
    jsonData: any;
}

// export default function NotificationStepper() {
const NotificationStepper: FC<NotificationStepperProps> = (props: NotificationStepperProps): React.ReactElement => {
    const {classes} = useStyles();
    const steps = getSteps(props.jsonData);
    return (
        <div className={classes.root}>
            <Stepper activeStep={steps.steps} alternativeLabel connector={<ColorlibConnector />}>
                {steps.data.map(label => (
                    <Step key={label.key}>
                        <StepLabel StepIconComponent={ColorlibStepIcon}>{label.key}</StepLabel>
                        <Typography
                            align="center"
                            variant="subtitle1"
                            className={label.date?.length == 0 ? 'date-lg-font mb-1rem' : 'date-lg-font'}
                        >
                            {label.date}
                        </Typography>
                        {(label.key == 'Loading' || label.key == 'Loaded' || label.key == 'On-Site') && (
                            <Grid className="top-text">
                                <Typography variant="body1">{label.text}</Typography>
                            </Grid>
                        )}

                        <Grid container>
                            <Grid size={12}>
                                <List>
                                    {label.data &&
                                        label.data &&
                                        label.data.length > 0 &&
                                        label.data.map((obj: LooseObject) => {
                                            return (
                                                <ListItem key={`${obj.key}-${obj.value}`}>
                                                    <ListItemText>
                                                        <>
                                                            <Typography variant="body1" display="inline">
                                                                {obj.key}:{' '}
                                                            </Typography>
                                                            <Typography variant="body2" display="inline">
                                                                {obj.value}
                                                            </Typography>
                                                        </>
                                                    </ListItemText>
                                                </ListItem>
                                            );
                                        })}
                                </List>
                            </Grid>
                        </Grid>
                    </Step>
                ))}
            </Stepper>
        </div>
    );
};

export default NotificationStepper;
